import { createActionTypes } from './utils/createActionTypes';

export default {
  products: {
    ...createActionTypes("products")
  },
  user: {
    ...createActionTypes("user")
  },
  companies: {
    ...createActionTypes("companies"),
    SET_IS_COMPANY_SELECTED: 'SET_IS_COMPANY_SELECTED'
  },
  routeDetails: {
    ROUTE_DETAILS: 'ROUTE_DETAILS'
  }
}